module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201112_388.ba7e1ccd.jpg";